<template>
    <van-popup get-container="body" :z-index="3000" class="buyDialog" v-model="show" @click-overlay="closeModal">
        <div class="title_x" @click="closeModal()">
            <svg t="1732585927904" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="6277" data-spm-anchor-id="a313x.search_index.0.i8.51fd3a819BMxuG" width="200" height="200">
                <path
                    d="M512 128c211.2 0 384 172.8 384 384s-172.8 384-384 384-384-172.8-384-384 172.8-384 384-384m0-64C262.4 64 64 262.4 64 512s198.4 448 448 448 448-198.4 448-448-198.4-448-448-448z"
                    fill="#999999" p-id="6278" data-spm-anchor-id="a313x.search_index.0.i7.51fd3a819BMxuG"
                    class="selected"></path>
                <path
                    d="M646.4 332.8L512 467.2 377.6 332.8c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8L467.2 512l-134.4 134.4c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l134.4 134.4c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l134.4-134.4c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z"
                    fill="#999999" p-id="6279" data-spm-anchor-id="a313x.search_index.0.i10.51fd3a819BMxuG"
                    class="selected"></path>
            </svg>
        </div>
        <div class="dialog" v-if="BuyType">
            <div class="dialog_tle">
                {{ $t('yi22') }}
            </div>

            <div class="dialog_body">
                <div class="dialog_body_name">{{ objData.goods_name || '' }}
                </div>

                <div class="dialog_body_stepper">
                    <span>{{ $t('yi23') }}</span>
                    <!-- <van-stepper v-model="num" disabled input-width="20px" button-size="16px" /> -->
                    <span>{{ num }}</span>
                </div>
                <div class="dialog_body_tips">{{ $t('yi24') }}</div>
                <div class="dialog_body_pri">{{ $t('yi25') }} <span>{{ (Number(num) * Number(objData.price)).toFixed(2)
                        }}USD</span>
                </div>
                <div :class="!isSucc ? 'dialog_body_suc' : 'dialog_body_err'">
                    {{ !isSucc ? $t('yi26') : $t('yi27') }}
                </div>
                <div class="dialog_body_yuan" v-if="isSucc">
                    {{ $t('yi28') }}{{ isSucc }}
                </div>
            </div>
        </div>


        <div class="dialog" v-else>

            <div class="dialog_tle">
                {{ isWin ? $t('yi29') : $t('new10') }}
            </div>

            <div class="dialog_emj" v-if="!isWin">
                <img src="../../../assets/image/one/hunt_emj.png" alt="">
            </div>

            <div class="slay flex">
                <span>{{ $t('yi30') }}</span>
                <div class="flex">
                    <div class="slay_btnx flex" v-for="(item, index) in generateArray(objData.lottery_number)"
                        :key="index">
                        <img src="../../../assets/image/one/hunt_btnx.png" alt="">
                        <div>{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="dialog_body" v-if="isWin">
                <div class="dialog_tle" style="margin-bottom: 10px;color: #EA1D10;">
                    {{ objData.phase_sn }}
                </div>

                <div class="slay_tle">
                    {{ $t('yi31') }}
                </div>
                <div class="slay_gx">
                    <!-- {{ $t('yi32') }} -->
                    {{ $t('new11') }} {{ objData.member_name || '' }} {{ $t('new12') }}
                </div>

                <div class="slay_time">
                    {{ $t('yi34') }}<br>{{ objData.created_time }}
                </div>

                <div class="slay_time">
                    {{ $t('yi33') }}<br>{{ objData.lottery_time }}
                </div>

                <div class="slay_time">
                    {{ $t('yi35') }} <span>{{ objData.number_count }}</span>
                </div>

                <div class="slay_time">
                    <a :href="'https://tronscan.org/#/block/' + objData.lottery_hash_no" target="_blank">{{
                        objData.lottery_hash }}</a>
                </div>

                <div class="slay_buy flex">
                    <div class="slay_buy_le">
                        {{ $t('yi36') }}
                    </div>
                    <div class="slay_buy_ri">
                        <span v-for="el in objData.number_list" :key="el">{{ el }}</span>
                    </div>
                </div>

                <div class="slay_btn">
                    <div @click="onGetGoods">{{ $t('yi37') }}</div>
                    <div @click="onCash" style="margin-left: 14px;">{{ $t('yi38') }}</div>
                </div>
            </div>

            <div class="dialog_body" style="padding: 10px" v-if="!isWin">
                <div class="dialog_tle" style="margin-bottom: 10px;color: #EA1D10;">
                    {{ objData.phase_sn }}
                </div>

                <div class="slay_tle">
                    {{ $t('yi31') }}
                </div>
                <div class="slay_gx">
                    {{ $t('new11') }} {{ objData.member_name || '' }} {{ $t('new12') }}
                </div>
                <div class="slay_tle" style="margin-bottom: 10px;">
                    <span>{{ objData.phase_sn }}</span>
                </div>

                <div class="slay_time">
                    <a :href="'https://tronscan.org/#/block/' + objData.lottery_hash_no" target="_blank">{{
                        objData.lottery_hash }}</a>
                </div>

                <div class="gds">
                    <div>{{ objData.goods_name }}</div>
                    <span>{{ $t('yi20') }}<i>{{ objData.usd || 0 }}USD</i></span>
                </div>
            </div>

        </div>

    </van-popup>
</template>

<script>
import { GetGoods, CloseLottery } from '../../../api/memberOne'
export default {
    props: {
        show: {
            default: false,
            type: Boolean
        },
        objData: {
            type: [Object, Array],
            default: () => ({})
        },
        num: {
            type: [String, Number],
            default: ''
        },
        isSucc: {
            default: '',
            type: String
        },
        BuyType: {
            default: true,
            type: Boolean
        },
        isWin: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            newId: [],
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        closeModal(v = 0) {
            if ((!this.BuyType) || v == 1) {
                this.onCloseLottery()
            }
            this.$emit('updateShow', false);
        },
        generateArray(num) {
            if (num === undefined || num === null) {
                num = 0;
            }
            const numString = num.toString().padStart(7, '0');
            return numString.split('').map(Number);
        },
        onGetGoods() {
            this.closeModal(1)
            this.$emit('onPagesWon', 'pickup')
        },
        onCash() {
            this.closeModal(1)
            this.$emit('onPagesWon', 'convert', this.objData)
        },
        // 关闭前回调
        onCloseLottery() {
            const { id } = this.objData
            CloseLottery({id}, 'one').then(res => { })
        }
    },
}
</script>

<style scoped lang="scss">
.flex {
    display: flex;
}

.buyDialog {
    width: 95%;
    max-width: 300px;
    // height: 283px;
    border: 1px solid #B15E3C;
    border-radius: 6px;
    padding: 16px;
    // max-height: 60%;
    background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
    box-sizing: border-box;

    .title_x {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 16px;
        right: 16px;

        svg {
            width: 20px;
            height: 20px;
        }
    }

    .dialog {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;

        .dialog_tle {
            // padding: 10px;
            font-size: 12px;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .dialog_emj {
            padding: 22px 0 15px;

            img {
                width: 56px;
                height: 44px;
            }
        }

        .dialog_body {
            flex: 1;
            width: 100%;
            box-sizing: border-box;
            border: 1px solid #F45C1D;
            border-radius: 4px;
            padding: 16px 25px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #333;

            // justify-content: center;
            .dialog_body_name {
                color: #666;
                margin-bottom: 10px;
                font-size: 12px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                line-height: 12px;
                text-align: center;
            }

            .dialog_body_stepper {
                display: flex;
                align-items: center;

                // position: relative;
                span {
                    margin-right: 16px;
                }

                // div{
                //     width: 100%;
                //     height: 100%;
                //     position: absolute;
                //     top: 0;
                //     right: 0;
                // }
            }

            .dialog_body_tips {
                padding: 10px 0 26px;
                color: #FF5F5F;
            }

            .dialog_body_pri {
                font-size: 13px;
                color: #000;
                font-family: CTHeiTiSF;

                span {
                    color: #EA1D10;
                }
            }

            .dialog_body_suc {
                color: #00A232;
                font-size: 12px;
                font-weight: 400;
                padding: 20px 0 10px;
            }

            .dialog_body_err {
                color: #EA170F;
                font-size: 12px;
                font-weight: 400;
                padding: 20px 0 10px;
            }

            .dialog_body_yuan {
                font-size: 12px;
                color: #333;
                text-align: center;
                padding-bottom: 15px;
            }

            .gds {
                display: flex;
                color: #333333;
                align-items: flex-end;

                div {
                    flex: 1;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    line-height: 12px;
                    font-size: 12px;
                    margin-right: 20px;
                }

                span {
                    font-size: 12px;

                    i {
                        color: #EA190F;
                        font-size: 12px;
                    }
                }
            }
        }


        .slay {
            width: 100%;
            background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
            border-radius: 4px;
            height: 51px;
            font-size: 12px;
            align-items: center;
            justify-content: center;
            color: #fff;
            margin-bottom: 8px;

            span {
                margin-right: 14px;
            }

            div {
                .slay_btnx {
                    width: 23px;
                    height: 23px;
                    position: relative;
                    color: #C10714;
                    font-size: 14px;
                    align-items: center;
                    justify-content: center;
                    // margin-right: 6px;

                    img {
                        position: absolute;
                        z-index: 0;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }

                    div {
                        text-align: center;
                        z-index: 133;
                    }
                }
            }
        }

        .slay_tle {
            font-size: 12px;
            color: #000;
            font-weight: bold;
        }

        .slay_gx {
            color: #EA1D10;
            font-size: 14px;
            padding: 13px 0 16px;
        }

        .slay_time {
            font-size: 12px;
            color: #000;
            font-weight: bold;
            margin-bottom: 10px;

            a {
                display: inline-block;
                text-align: center;
                max-width: 200px;
                color: #EA1D10;
                overflow-wrap: break-word;
            }

            span {
                color: #EA1D10;
            }
        }

        .slay_buy {
            width: 100%;
            justify-content: space-between;
            flex-direction: column;

            .slay_buy_le {
                font-weight: bold;
                font-size: 12px;
                color: #000;
                margin-bottom: 2px;
            }

            .slay_buy_ri {
                color: #EA1D10;
                margin-left: 10px;
                flex: 1;
                max-height: 60px;
                overflow-y: auto;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
            }
        }

        .slay_btn {
            width: 100%;
            display: flex;
            // height: 23px;
            margin-top: 10px;

            div {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;
                background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                border-radius: 11px;
                color: #fff;
                text-align: center;
                padding: 5px;
            }
        }
    }
}
</style>